<script setup>
import WarehouseDocumentGrid from '@/components/registry/WarehouseDocumentGrid.vue'
</script>
<template>
  <warehouse-document-grid />
</template>

